<script setup>
import { ref } from 'vue'
import { useNotification } from '@kyvg/vue3-notification'
import DynamicService from '@/services/DynamicService'
import ModalBox from './ModalBox.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import Alert from '@/components/Atoms/Alert.vue'
import FormInput from '@/components/Atoms/FormInput.vue'
import { track, EVENTS } from '@/lib/tracking'

const { notify } = useNotification()

const emit = defineEmits(['player-added'])

const isVisible = ref(false)
const playerName = ref('')
const error = ref(null)

const toggleModal = () => {
	isVisible.value = !isVisible.value
}

const closeModal = () => {
	playerName.value = ''
	isVisible.value = false
}

const onReset = () => {
	error.value = null
}

const onConfirm = async () => {
	try {
		const newPlayer = await DynamicService.createPlayer(playerName.value)
		track(EVENTS.DYNAMIC_PLAYER_CREATED, { playerId: newPlayer._id })
		notify({ group: 'success', text: 'Dynamic player created.' })
		closeModal()
		emit('player-added', newPlayer._id)
	} catch (err) {
		error.value = err.message || err
	}
}

defineExpose({ toggleModal })
</script>

<template>
	<ModalBox v-model="isVisible" size="sm" mobile-placement="bottom" title="Create new dynamic player"
		wrapper-classes="md:max-h-[90vh] overflow-y-auto" header-class="!border-b !border-surface-3 !py-3 !mb-3"
		@close="onReset">
		<div class="flex flex-col w-full px-6 pb-6">
			<Alert v-if="error" type="error" class="flex items-start px-2">
				<div class="-mt-1">
					<p class="text-sm mb-0">{{ error }} or contact the
						<FormButton type="link" size="sm" class="underline text-white" onclick="Intercom('show')">sales</FormButton>
						team.
					</p>
				</div>
			</Alert>

			<FormInput label="Player name" v-model="playerName" placeholder="Main dynamic player" />

			<div class="text-center mt-4 lg:border-t lg:border-surface-3 pt-4 flex flex-col gap-2 lg:flex-row lg:justify-end">
				<FormButton type="secondary" size="md" class="justify-center order-2 lg:order-1" @click="closeModal">
					Cancel
				</FormButton>
				<FormButton :disabled="playerName.length === 0" @click="onConfirm" type="main" size="md"
					class="justify-center order-1 lg:order-2">
					Create Player
				</FormButton>
			</div>
		</div>
	</ModalBox>
</template>

<style scoped></style>
